import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  signOut,
} from "firebase/auth";

const auth = getAuth();

interface EmailPasswordLoginType {
  email: string;
  password: string;
  name?: string | null;
}

export const registerUserWithEmailAndPassword = ({
  email,
  password,
  name,
}: EmailPasswordLoginType) => {
  createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      if (name) updateProfile(user, { displayName: name });
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      // ..
    });
};

export const signInUserWithEmailAndPassword = ({
  email,
  password,
}: EmailPasswordLoginType) => {
  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
    });
};

export const logOut = () => {
  signOut(auth).then((response) => {
    console.log(response);
  });
};
